<template>
    <div class="ps-section__content">
        <div v-if="isLoading">
            <div class="half-circle-spinner">
                <div class="circle circle-1"></div>
                <div class="circle circle-2"></div>
            </div>
        </div>
        <div v-if="!isLoading" v-carousel class="ps-carousel--nav owl-slider"
             data-owl-auto="true"
             data-owl-loop="false"
             data-owl-speed="10000"
             data-owl-gap="30"
             data-owl-nav="true"
             data-owl-dots="true"
             data-owl-item="6"
             data-owl-item-xs="2"
             data-owl-item-sm="2"
             data-owl-item-md="3"
             data-owl-item-lg="4"
             data-owl-item-xl="5"
             data-owl-duration="1000"
             data-owl-mousedrag="on"
        >
            <div class="ps-product" v-for="item in products" :key="item.id" v-if="products.length" v-html="item"></div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                isLoading: true,
                products: [],
            };
        },
        props: {
            url: {
                type: String,
                default: () => null,
                required: true
            },
        },
        mounted() {
          this.getData();
        },
        methods: {
            getData() {
                const thisClass = this;
                this.products = [];
                this.isLoading = true;
                axios.get(this.url)
                    .then(res => {
                        thisClass.products = res.data.data ? res.data.data : [];
                        thisClass.isLoading = false;
                    })
                    .catch(res => {
                        thisClass.isLoading = false;
                    });
            },
        },
    }
</script>
